import type { LocalMarketApiDto } from '__generated__/api/unauth/types.gen';

import { SearchEmptyResults } from '../SearchEmptyResults';
import { SearchMarketCard } from './SearchMarketCard';

export function LocalMarketList({ items }: { items: LocalMarketApiDto[] }) {
  if (items.length < 1) return <SearchEmptyResults />;

  return (
    <ul className="grid grid-cols-3 gap-x-16 gap-y-32 pb-40 mobile:gap-x-12 mobile:gap-y-24 mobile-tablet:grid-cols-2 mobile-tablet:px-20">
      {items.map((item) => (
        <li key={item.localMarketProductId}>
          <SearchMarketCard
            productId={item.localMarketProductId}
            imageUrl={item.productImageUrl}
            productName={item.productName}
            region={item.region}
            originalPrice={item.originalPrice}
            expectedFinalPrice={item.expectedFinalPrice}
            discountRate={item.discountRate}
            rating={item.rating}
            reviewCount={item.reviewCount}
          />
        </li>
      ))}
    </ul>
  );
}
